import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';

const LaVallePersonalShopper = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        width={['100vw', '100vw', '760px', '1000px']}
        height={['100%', '100%', '580px', '660px']}
        overflowY={['auto', 'auto', 'hidden']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box display="flex" flexDirection={['column', 'column', 'row']}>
          <Box w={['100%', '100%', '360px', '400px']} h={['500px', '500px', '580px', '700px']}>
            {active && (
              <ReactPlayer
                progressInterval={1}
                height="100%"
                width="inherit"
                loop={true}
                muted
                controls={false}
                playing={active}
                url="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bister/lavalle/personal-shopper.mp4"
                playsinline
              />
            )}
          </Box>
          <Box display="flex" flexDirection="column" mt={['5', '5', '0']} justifyContent="center" alignItems="center">
            <Box
              display="flex"
              flexDirection="column"
              h={['250px', '250px', '430px', '550px']}
              justifyContent="center"
              alignItems="center"
              gap={['6', '6', '10']}
            >
              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="SangBleuBPLight"
                fontSize={['16px', '16px', '18px', '20px', '20px']}
                maxW="80%"
                mx="auto"
                whiteSpace="pre-line"
              >
                {t('lv_personal_shopper_title')}
              </Text>
              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
                maxW="80%"
                mx="auto"
              >
                {t('lv_personal_shopper_description')}
              </Text>

              <Text
                as="i"
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '15px', '15px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
                className="gold"
                maxW="80%"
              >
                {t('lv_personal_shopper_text')}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LaVallePersonalShopper;
